import useTranslations from "../../core/i18n/useTranslations";
import { useSaveObject } from "../../core/SaveObjectContext/hooks";
import PrimeModal from "../../ui-lib/components/PrimeModal/PrimeModal";

export const RetentionConfirmModal = ({
  isOpen,
  onClose,
  onSubmit,
}: {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => Promise<void>;
}) => {
  const t = useTranslations();
  const { isSaving } = useSaveObject();
  return (
    <PrimeModal
      withFooter
      withHeader
      fixedWidth="576px"
      header={t("Organizations:apply_retention_changes")}
      loading={isSaving}
      isOpen={isOpen}
      onClose={onClose}
      submitBtn={{ text: t("Common:save_changes"), onClick: onSubmit }}
      cancelBtn={{ text: t("Common:cancel"), onClick: onClose }}
    >
      <p>{t("Organizations:confirm_retention_changes_description")}</p>
    </PrimeModal>
  );
};
